export enum ImmediateReservationPriceType {
    'Full' = 'Full',
    'None' = 'None',
    'Partial' = 'Partial',
}
